<template>
  <span class="d-print-none">
    <v-btn
      :color="color"
      v-bind="$attrs"
      :loading="externalLoading || loading"
      text
      :class="buttonClass"
      :disabled="disabled"
      :dark="!disabled"
      @click="() => printHandler()"
    >
      <slot name="button-content">
        <v-icon left>$iconPrint</v-icon
        >{{ $t("common:button.exportPrint", "Print") }}
      </slot>
    </v-btn>
    <iframe
      ref="iframe"
      name="printArea"
      aria-hidden="true"
      class="d-none"
      sandbox="allow-same-origin allow-modals"
    />
  </span>
</template>
<script setup>
import { ref } from "vue";
import { usePrint } from "@composables/print";
// name: "AppPrint"
const props = defineProps({
  elementId: {
    type: String,
    default: null
  },
  dataElementId: {
    type: String,
    default: null
  },
  element: {
    type: Function,
    default: null
  },
  externalLoading: {
    type: Boolean,
    default: false
  },
  customHandle: {
    type: Function,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: "primary"
  },
  buttonClass: {
    type: [String, Object],
    default: () => undefined
  }
});

const loading = ref(false);
const iframe = ref(null);
const { startPrint } = usePrint();

function printHandler() {
  if (typeof props.customHandle === "function") {
    props.customHandle();
    return;
  }
  print();
}

async function print() {
  loading.value = true;
  await startPrint({
    elementId: props.elementId,
    dataElementId: props.dataElementId,
    element: props.element,
    iframe: iframe.value
  });
  loading.value = false;
}

defineExpose({
  print
});
</script>
